import {Types} from 'mongoose';
import {PARTICIPANT_TYPE_TENANT_ID, PARTICIPANT_TYPE_TENANT_LABEL} from './tenancy-participant-type.consts';

export const TENANCY_PARTICIPANT_TYPE = {
    type: 'Tenancy Participant Type',
    category: 'System',
    value: [
        {label: PARTICIPANT_TYPE_TENANT_LABEL, _id: new Types.ObjectId(PARTICIPANT_TYPE_TENANT_ID)},
        {label: 'Landlord', _id: new Types.ObjectId('507f1f77bcf86cd799439011')},
        {label: 'Other', _id: new Types.ObjectId('507f1f77bcf86cd799439012')},
    ].map(d => ({...d, active: true})),
};
